import React, { useEffect, useState } from "react";
import styles from "./DocumentsViewer.module.css";
import { useGetConceptsFiltersMutation } from "../../../store/api/lumi/concepts";
import { getConceptFilter } from "../../../utils/getConceptFilter";
import { debounce } from "lodash";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const DocumentsViewer = (props) => {
    const { filterDocCount } = props;
    const formattedDocCount = filterDocCount ? filterDocCount.toLocaleString() : "0";
    const [getVolumes] = useGetConceptsFiltersMutation();
    const [isLoading, seIstLoading] = useState(false);

    async function getVolume() {
        seIstLoading(true);
        const conceptFilter = getConceptFilter(props);

        const { data: dataConcepts } = await getVolumes({
            id: props.id,
            concept_selector: conceptFilter,
            filter: props.filters,
        });
        let results = dataConcepts.match_counts;
        if (props && props.conceptList) {
            props.setLocalConceptOptions(results);
        }
        props.setFilterDocCount(dataConcepts.filter_count);
        seIstLoading(false);
    }

    useEffect(() => {
        seIstLoading(true);
        const debouncedGetVolume = debounce(getVolume, 500);
        debouncedGetVolume();
        return () => {
            debouncedGetVolume.cancel();
        };
    }, [
        props.filters,
    ]);

    if (isLoading) {
        return (
            <Spin
                className={"spinner-by-center"}
                indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            />
        );
    }

    return (
        <div className={styles.documentsViewerContainer}>
            <div className={styles.documentsViewerInner}>
                <div className={styles.docCount}>
                    {formattedDocCount}
                </div>
            </div>
            <div className={styles.documentInfo}>
            </div>
        </div>

    );
};

export default DocumentsViewer;
